import styled from "styled-components";
import { Link } from "react-router-dom";

const TitleText = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-size: var(--font-size-big);
  font-weight: bold;
  color: var(--color-main);
`;

const ItemText = styled.div`
  width: 120px;
  font-size: var(--font-size-medium);
  font-weight: bold;
  color: var(--color-black);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  white-space: nowrap;
`;

const TableItemText = styled.div`
  height: 35px;
  font-size: var(--font-size-medium);
  font-weight: bold;
  color: var(--color-black);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TableDataText = styled.div`
  height: 35px;
  background-color: var(--color-white);
  padding: 0 10px;
  font-size: var(--font-size-small);
  font-weight: normal;
  color: var(--color-black);
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .blue {
    color: var(--color-blue);
    font-weight: bold;
  }
`;

const TableDataButton = styled(Link)`
  padding: 0 10px;
  font-size: var(--font-size-small);
  font-weight: normal;
  color: var(--color-black);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  border: transparent;
  margin: 0;
  text-decoration: none;

  .blue {
    color: var(--color-blue);
    font-weight: bold;
  }

  .underline {
    text-decoration: underline;
  }
`;

export { TitleText, ItemText, TableItemText, TableDataText, TableDataButton };
